import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    editAndShareWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginTop: Spacings.s24,
      gap: Spacings.s8,

      [BreakPointsMedia.SM]: {
        display: 'flex',
        alignItems: 'center',
        marginTop: Spacings.s16,
      },
      [BreakPointsMedia.XS]: {
        display: 'flex',
        alignItems: 'center',
        marginTop: Spacings.s16,
      },
      [BreakPointsMedia.XXS]: {
        display: 'flex',
        alignItems: 'center',
        marginTop: Spacings.s16,
      },
    },

    editBtn: {
      flexGrow: 1,
    },
  },
  {
    name: 'edit-and-share',
  },
);

export default useStyles;
